"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _popover = require("baseui/popover");

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This is a basic popover based on
 * [baseui popover](https://baseweb.design/components/popover/).
 */
const Popover = props => {
  const {
    overrides,
    zIndex,
    ...popoverProps
  } = props;
  return /*#__PURE__*/_react.default.createElement(_popover.StatefulPopover, _extends({
    showArrow: true,
    overrides: {
      Body: {
        style: styleArgs => (0, _style.getBodyStyle)(zIndex, styleArgs)
      },
      Inner: {
        style: styleArgs => (0, _style.getInnerStyle)(styleArgs)
      },
      Arrow: {
        style: styleArgs => (0, _style.getArrowStyle)(styleArgs)
      },
      ...(overrides || {})
    }
  }, popoverProps));
};

var _default = Popover;
exports.default = _default;